export const getLanguage = (locale: SupportedLocale) => locale.split('-')[0].toLowerCase();

export const getCountry = (locale: SupportedLocale) => {
  if (locale === 'en') {
    return 'us';
  }

  return locale.split('-')[1].toLowerCase();
};
